// ============================================================
//  src/admin/pages/AdminLoginPage.js
// ============================================================
import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import toast from 'react-hot-toast';
import { useAdminAuth } from '../context/AdminAuthContext';
import '../styles/admin.css';

export default function AdminLoginPage() {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [loading, setLoading] = useState(false);
  const { login } = useAdminAuth();
  const navigate = useNavigate();

  async function handleSubmit(e) {
    e.preventDefault();
    setLoading(true);
    try {
      await login(email.trim(), password);
      navigate('/bot-father/dashboard', { replace: true });
    } catch (err) {
      toast.error(err?.response?.data?.message || 'Login failed');
    } finally {
      setLoading(false);
    }
  }

  return (
    <div className="bf-admin" style={{
      display: 'flex', alignItems: 'center', justifyContent: 'center',
      minHeight: '100dvh', background: 'var(--bf-bg)', padding: 20,
    }}>
      <form onSubmit={handleSubmit} className="bf-card" style={{ width: '100%', maxWidth: 380, marginBottom: 0 }}>
        <div className="bf-card-hdr" style={{ justifyContent: 'flex-start', gap: 10 }}>
          <span style={{ fontSize: 17 }}>🛡️</span> Bot-Father Admin
        </div>
        <div className="bf-card-body" style={{ display: 'flex', flexDirection: 'column', gap: 14 }}>
          <div className="bf-field">
            <label className="bf-field-label">Email</label>
            <input
              className="bf-input"
              type="email" required value={email} onChange={e => setEmail(e.target.value)}
              autoComplete="username"
            />
          </div>
          <div className="bf-field">
            <label className="bf-field-label">Password</label>
            <input
              className="bf-input"
              type="password" required value={password} onChange={e => setPassword(e.target.value)}
              autoComplete="current-password"
            />
          </div>
          <button className="btn btn-primary bf-full" type="submit" disabled={loading} style={{ marginTop: 4 }}>
            {loading ? <><span className="spinner" /> Signing in…</> : 'Sign in'}
          </button>
        </div>
      </form>
    </div>
  );
}